<template>
  <el-dialog
      :width="screenWidth<=976?'85%':'964px'"
      append-to-body
      :show-close="showClose"
      :visible.sync="dialogFormVisible"
      @closed="closeDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
    <slot name="htmlText"></slot>
  </el-dialog>
</template>

<script>
export default {
  name: "htmlModal",
  props:{
    showClose:{
      type:Boolean,
      default:()=>{
        return true
      }
    }
  },
  data(){
    return{
      dialogFormVisible:false,
      screenWidth:null,

    }
  },
  methods:{
    init(){
      this.dialogFormVisible = true;
    },
    closeDialog(){

    },
    calcWidth() {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.$forceUpdate();
    },
  },
  mounted(){
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
.img{
  max-width:100%;
  object-fit: contain;
}

</style>